export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f4be3560bd8d89c241b02f1c98ffe9d9dcc5640d4&name=fetchTypeahead!'